export default [
    {
        label: '名字',
        key: 'firstName',
    },
    {
        label: '姓',
        key: 'lastName',
    },
    {
        label: '地址',
        key: 'address1',
    },
    {
        label: '门牌',
        key: 'address2',
    },
    {
        label: '城市',
        key: 'city',
    },
    {
        label: '国家',
        key: 'country',
    },
    {
        label: '省份',
        key: 'province',
    },
    {
        label: '邮编',
        key: 'zip',
    },
    {
        label: '电话',
        key: 'phone',
    },
]
